export default "/assets/active-carousel-arrow.svg";